import { SectionRestrictionTypeEnum } from '@app/sidebar-layout/enums/section-restriction-type.enum';
import { ISidebarRestrictions } from '@app/sidebar-layout/interfaces/i-sidebar-restrictions';

export interface ISectionRestriction {
	restrictionKey: keyof ISidebarRestrictions;
	type: SectionRestrictionTypeEnum;
	isAllowed: boolean;
}

export const Restrictions: ISectionRestriction[] = [
	{
		type: SectionRestrictionTypeEnum.OrganizationPicker,
		restrictionKey: 'isOrganizationPickerAllowed',
		isAllowed: false,
	},
	{
		type: SectionRestrictionTypeEnum.Notifications,
		restrictionKey: 'isNotificationsAllowed',
		isAllowed: false,
	},
	{
		type: SectionRestrictionTypeEnum.AddAccount,
		restrictionKey: 'isAddAccountAllowed',
		isAllowed: false,
	},
	{
		type: SectionRestrictionTypeEnum.AuditLog,
		restrictionKey: 'isAuditLogAllowed',
		isAllowed: false,
	},
];
